// The "common sense heat pump sizing" Tally form. Distinct from the waitlist
// form embedded in Contact.js (wM9zA0).
export const SIZING_FORM_ID = 'J9xyPR';
export const SIZING_FORM_PATH = '/heat-pump-sizing';

// Opens the sizing form as a Tally popup overlay. The embed script is loaded
// async in public/index.html, so on a fast click it may not be there yet —
// fall back to the standalone page rather than doing nothing.
export const openSizingForm = () => {
  if (window.Tally && typeof window.Tally.openPopup === 'function') {
    window.Tally.openPopup(SIZING_FORM_ID, {
      layout: 'modal',
      width: 700,
      hideTitle: true,
      overlay: true,
    });
    return;
  }
  window.location.href = SIZING_FORM_PATH;
};
